import moment from "jalali-moment";

export const StartCurrentMonth = () => {
    const startOfMonth = moment().locale('fa').startOf('month').format('YYYY-MM-DD');
    const miladiStart = moment.from(startOfMonth, 'fa', 'YYYY-MM-DD').format('YYYY-MM-DD')
    return miladiStart
}